export enum WalletType {
  BASIC = "BASIC",
  SMART = "SMART",
}
